<h1 mat-dialog-title>Add new filter</h1>
<mat-dialog-content class="dialog-content">
  <h4>Filters expression:</h4>
  <pre>
    {{ getLogicalExpression(filter) }}
  </pre>
  <gymfinder-filter
    [(filter)]="filter"
    [studioTypes]="studioTypes"
    [activities]="activities"
    [services]="services"
    [gymTypes]="gymTypes"
    [gymEquipments]="gymEquipments"
    [equipmentsToBring]="equipmentsToBring"
    [networks]="networks"
    [gymInfos]="gymInfos"
    [geniusFeatures]="geniusFeatures"></gymfinder-filter>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="closeDialog()">Cancel</button>
  <button mat-raised-button color="primary" (click)="createFilter()">
    Create
  </button>
</mat-dialog-actions>
